import {
  BankOutlined,
  CreditCardOutlined,
  GiftFilled,
  // FundOutlined,
  GiftOutlined,
  IdcardOutlined,
  MessageOutlined,
  QrcodeOutlined,
  SnippetsOutlined,
  TransactionOutlined,
  UserOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { MenuType } from "types/menu";

import { PATH } from "./path";

export const MENU_USER_LIST: MenuType[] = [
  {
    icon: <UserOutlined />,
    label: <NavLink to={PATH.user.profile}>My profile</NavLink>,
  },
  {
    icon: <IdcardOutlined />,
    label: <NavLink to={PATH.user.account}>Accounts</NavLink>,
  },
  {
    icon: <CreditCardOutlined />,
    label: <NavLink to={PATH.user.deposit}>Deposits</NavLink>,
  },
  {
    icon: <BankOutlined />,
    label: <NavLink to={PATH.user.bank}>Bank</NavLink>,
  },
  {
    icon: <TransactionOutlined />,
    label: <NavLink to={PATH.user.cashWithdraw}>Cash withdrawal</NavLink>,
  },
  {
    icon: <SnippetsOutlined />,
    label: (
      <NavLink to={PATH.user.transactionHistory}>Transaction history</NavLink>
    ),
  },
  {
    icon: <GiftFilled />,
    label: <NavLink to={PATH.user.myBonus}>My bonus</NavLink>,
  },
  {
    icon: <GiftOutlined />,
    label: <NavLink to={PATH.user.bonusHistory}>Bonus history</NavLink>,
  },
  {
    icon: <VerticalAlignBottomOutlined />,
    label: <NavLink to={PATH.user.documents}>Documents</NavLink>,
  },
  {
    icon: <MessageOutlined />,
    label: <NavLink to={PATH.user.messages}>Messages</NavLink>,
  },
  {
    icon: <QrcodeOutlined />,
    label: <NavLink to={PATH.user.referral}>Referral</NavLink>,
  },
];
